export enum ChallengeTargetOperatorEnum {
  MAX = 'Max',
  MIN = 'Min',
}
